import styled from '@emotion/styled';
import { mediaQuery } from '@presentation/styles';

export const Wrapper = styled.div`
  height: 100%;
  width: 100%;
`;

export const Section = styled.section`
  padding: 40px;
  margin-bottom: 50px;
  text-align: center;
  width: 100%;
  background: white;
  border-radius: 8px;
  box-shadow: 0 10px 18px 0 rgba(0, 0, 0, 0.06);
`;

export const ImageWrapper = styled.div`
  position: absolute;
  right: -110px;
  top: -108px;
  width: 200px;
  z-index: 1;
  img {
    width: 100%;
  }

  ${mediaQuery('tablet')} {
    left: 0;
  }
`;

export const StepLineWrapper = styled.div`
  border: 1px solid #f0f0f0;
  border-radius: 8px;
  margin: 24px 0;
  padding: 32px;
`;
